import { CrudEndpoint } from '@/api/common/CrudEndpoint';
import { ShopifyProductDTO } from '@/api/dto/ShopifyProductDTO';

export class ShopifyProductCRUD extends CrudEndpoint<ShopifyProductDTO> {
  constructor() {
    super('shopifyproduct');
  }
}
